import { createExamColumnDefs } from "modules/constants/QuestionBankConstants";
import React from "react";
import Grid from '../../platform-components/grid/Grid';

export const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#eee",
    border: "unset",
    padding: "0px",
    maxHeight: "60px",
    overflow: "auto",
  }),
  input: (styles) => ({ ...styles, border: "unset" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#333",
    fontSize: "15px",
    paddingLeft: "8px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    width: "15px",
    padding: "0px",
    color: "black",
  }),
};

export function getUniqueAfterMerge(arr1, arr2) {
  // merge two arrays using spread operator
  const arr = [...arr1, ...arr2];
  // loop through array and use Set to find unique values
  let uniqueArr = [...new Set(arr)];

  return uniqueArr;
}

export const tabList = props => {
    if (props.status) {
      return [
        {
          label: `Selected (${props?.manualQuestions.length})`,
          content: (
            <>
              <div
                style={{
                  height: "270px",
                  maxHeight: "270px",
                  overflow: "auto",
                  padding: "0px",
                }}
              >
                <div className="">
                  <Grid
                    gridOptions={{
                      rowData: props?.fullQuestions.filter(el =>
                        props?.manualQuestions.includes(el.questionId)
                      ),
                      onSelectionChanged: params => {
                        const selectedRows = params.api
                          .getSelectedRows()
                          .map(e => e?.questionId);
  
                        const newSelectionHistory = props?.manualQuestions.filter(
                          el => selectedRows.includes(el)
                        );
                        props.setManualQuestions(newSelectionHistory);
                        props.gridApi2.current.forEachNode(node => {
                          node.setSelected(
                            !!node.data &&
                              newSelectionHistory.includes(node.data.questionId)
                          );
                        });
                      },
                      suppressRowClickSelection: true,
                      rowSelection: "multiple",
                      pagination: true,
                      columnDefs: createExamColumnDefs,
                      isRowSelectable: (params) => {
                        return false;
                        },
                      onFirstDataRendered: params => {
                        props.gridApi2.current = params.api;
  
                        props.gridApi2.current.forEachNode(node => {
                          node.setSelected(
                            !!node.data &&
                              props.manualQuestions.includes(node.data.questionId)
                          );
                        });
                      },
                    }}
                    parent="createexam"
                  />
                </div>
              </div>
            </>
          )
        }
      ]
    }
      
    return [
      {
        label: `Searched Question (${props?.gridOptions.rowData.length})`,
        content: (
          <>
            <div
              style={{
                height: "270px",
                maxHeight: "270px",
                overflow: "auto",
                padding: "0px",
              }}
            >
              <Grid gridOptions={props?.gridOptions} parent="createexam" />
            </div>
          </>
        )
      },
      {
        label: `Selected (${props?.manualQuestions.length})`,
        content: (
          <>
            <div
              style={{
                height: "270px",
                maxHeight: "270px",
                overflow: "auto",
                padding: "0px",
              }}
            >
              <div className="">
                <Grid
                  gridOptions={{
                    rowData: props?.fullQuestions.filter(el =>
                      props?.manualQuestions.includes(el.questionId)
                    ),
                    onSelectionChanged: params => {
                      const selectedRows = params.api
                        .getSelectedRows()
                        .map(e => e?.questionId);
  
                      const newSelectionHistory = props?.manualQuestions.filter(
                        el => selectedRows.includes(el)
                      );
                      props.setManualQuestions(newSelectionHistory);
                      props.gridApi2.current.forEachNode(node => {
                        node.setSelected(
                          !!node.data &&
                            newSelectionHistory.includes(node.data.questionId)
                        );
                      });
                    },
                    suppressRowClickSelection: true,
                    rowSelection: "multiple",
                    pagination: true,
                    columnDefs: createExamColumnDefs,
                    onFirstDataRendered: params => {
                      props.gridApi2.current = params.api;
  
                      props.gridApi2.current.forEachNode(node => {
                        node.setSelected(
                          !!node.data &&
                            props.manualQuestions.includes(node.data.questionId)
                        );
                      });
                    },
                  }}
                  parent="createexam"
                />
              </div>
            </div>   
        </>
      ),
    },
  ];
};
